<template>
    <v-row>
        <v-col sm="12" lg="6">
            <v-btn variant="text" @click="restore" style="width: 100%">
                Restore
                <v-icon right> mdi-refresh </v-icon>
            </v-btn>
        </v-col>
        <v-col sm="12" lg="6">
            <v-btn variant="text" @click="share" style="width: 100%">
                share
                <v-icon right> mdi-share-variant-outline </v-icon>
            </v-btn>
        </v-col>
        <v-col sm="12" lg="6">
            <v-btn variant="text" @click="genhtml" style="width: 100%">
                HTML
                <v-icon right>mdi-tray-arrow-down</v-icon>
            </v-btn>
        </v-col>
        <v-col sm="12" lg="6">
            <PdfButton :record="record" :text="true" :maxWidth="true" />
        </v-col>
    </v-row>
</template>
<script setup>
import { useStore } from 'vuex'
import PdfButton from '../shared/PdfButton.vue'

const store = useStore()
const props = defineProps(['record'])
const emit = defineEmits(['restore', 'share'])

async function genhtml() {
    props.record.showProgress = true
    store.dispatch('printHtml', props.record)
    props.record.showProgress = false
}

function restore() {
    emit('restore')
}

function share() {
    emit('share')
}
</script>
